import { useState, useEffect } from "react";
import { Message } from "@/app/(routes)/chatbot-ui/page";

export const useChatHistory = (
  chatMessages: Message[],
  isGenerating: boolean,
  setUserInput: (input: string) => void
) => {
  const [messageHistoryIndex, setMessageHistoryIndex] = useState<number>(
    chatMessages.length
  );

  useEffect(() => {
    if (!isGenerating && messageHistoryIndex > chatMessages.length) {
      setMessageHistoryIndex(chatMessages.length);
    }
  }, [chatMessages, isGenerating, messageHistoryIndex]);

  const setNewMessageContentToPreviousUserMessage = () => {
    let tempIndex = messageHistoryIndex;
    while (
      tempIndex > 0 &&
      chatMessages[tempIndex - 1].role !== "user"
    ) {
      tempIndex--;
    }

    const previousUserMessage =
      chatMessages.length > 0 && tempIndex > 0
        ? chatMessages[tempIndex - 1]
        : null;
    if (previousUserMessage) {
      setUserInput(previousUserMessage.content);
      setMessageHistoryIndex(tempIndex - 1);
    }
  };

  const setNewMessageContentToNextUserMessage = () => {
    let tempIndex = messageHistoryIndex;
    while (
      tempIndex < chatMessages.length - 1 &&
      chatMessages[tempIndex + 1].role !== "user"
    ) {
      tempIndex++;
    }

    const nextUserMessage =
      chatMessages.length > 0 && tempIndex < chatMessages.length - 1
        ? chatMessages[tempIndex + 1]
        : null;
    setUserInput(nextUserMessage?.content || "");
    setMessageHistoryIndex(
      nextUserMessage ? tempIndex + 1 : chatMessages.length
    );
  };

  return {
    setNewMessageContentToPreviousUserMessage,
    setNewMessageContentToNextUserMessage
  };
}; 